import { motion } from "framer-motion";

const tickerLabels = [
  "Verified members across the corridor",
  "Africa · Asia · Middle East",
  "Cross-border trade facilitation",
  "Verified businesses",
  "Trade matchmaking",
  "Government & chamber liaison",
  "Member directory",
  "Events & conclaves",
  "ESG Readiness Index",
  "Investor pipeline",
  "Marketplace for goods & services",
  "AAMECC Digital",
];

const LiveTicker = () => {
  const items = [...tickerLabels, ...tickerLabels];

  return (
    <div className="bg-navy border-b border-navy-light overflow-hidden py-2">
      <motion.div
        className="flex gap-8 whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
      >
        {items.map((label, index) => (
          <div
            key={index}
            className="flex items-center gap-2 text-xs text-white shrink-0"
          >
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-gold" />
            <span className="font-medium tracking-wide text-white/80">
              {label}
            </span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default LiveTicker;
